import { render } from "./PointsCard.vue?vue&type=template&id=4928a116&scoped=true&ts=true"
import script from "./PointsCard.vue?vue&type=script&lang=ts"
export * from "./PointsCard.vue?vue&type=script&lang=ts"

import "./PointsCard.vue?vue&type=style&index=0&id=4928a116&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4928a116"]])

export default __exports__